import { useState, memo, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";

import ALLoading from "./ALLoading";

import "./alButton/styles.scss";

function ALButton({
  className = "",
  size = "medium",
  variant = "primary",
  isLoading = false,
  type = "button",
  pillButton = true,
  fullWidth = false,
  buttonBackgroundColor = "",
  buttonTextColor = "",
  onClick = () => {},
  children,
  ...rest
}) {
  const buttonRef = useRef(null);
  const [hovered, setHovered] = useState(false);

  const applyStyles = (bg, border, color) => {
    if (buttonRef.current) {
      buttonRef.current.style.setProperty("background-color", bg, "important");
      buttonRef.current.style.setProperty("border-color", border, "important");
      buttonRef.current.style.setProperty("color", color, "important");
    }
  };

  useEffect(() => {
    if (!hovered) {
      applyStyles(buttonBackgroundColor, buttonBackgroundColor, buttonTextColor);
    }
  }, [buttonBackgroundColor, buttonTextColor, hovered]);

  const handleFocus = () => {
    setHovered(true);
    applyStyles(buttonTextColor, buttonBackgroundColor, buttonBackgroundColor);
  };

  const handleMouseOver = () => {
    setHovered(true);
    applyStyles(buttonTextColor, buttonBackgroundColor, buttonBackgroundColor);
  };

  const handleMouseLeave = () => {
    setHovered(false);
    applyStyles(buttonBackgroundColor, buttonBackgroundColor, buttonTextColor);
  };

  return (
    <button
      ref={buttonRef}
      className={`button button--${size} button--${variant} ${
        isLoading ? "al_button--loading" : ""
      } ${fullWidth ? "button--fullWidth" : ""} ${
        !pillButton ? "button-sm-radius" : ""
      } ${className}`}
      onClick={onClick}
      onMouseOver={handleMouseOver}
      onFocus={handleFocus}
      onMouseLeave={handleMouseLeave}
      type={type}
      {...rest}
    >
      {isLoading ? <ALLoading /> : children}
    </button>
  );
}

ALButton.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.oneOf(["primary", "secondary", "tertiary", "black", "white", "plain"]),
  pillButton: PropTypes.bool,
  isLoading: PropTypes.bool,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  onClick: PropTypes.func,
  fullWidth: PropTypes.bool,
  buttonBackgroundColor: PropTypes.string,
  buttonTextColor: PropTypes.string,
  children: PropTypes.node,
};

export default withALErrorBoundary({
  name: "ALButton",
  priority: "P1",
})(memo(ALButton));
